import { Injectable } from '@angular/core';
import { ValidatorService } from 'src/app/core/validator/validator.service';
import { WarehouseStorageRate } from '../models/warehouse-storage-rate.model';

/**
 * A rate is money that multiplies a day count, so the checks here are deliberately stricter than
 * "is it filled in": a blank rate must not reach the table as a zero, because a zero is a real
 * price - free storage - and would bill silently rather than fail.
 */
@Injectable({
  providedIn: 'root'
})
export class WarehouseStorageRateValidatorService extends ValidatorService {

  isValid(data: WarehouseStorageRate) {
    this.errors = [];

    if (!data.accountId || data.accountId === -1) {
      this.errors.push('accountId');
    }

    if (!data.unitId || data.unitId === -1) {
      this.errors.push('unitId');
    }

    if (!this.isRate(data.storageRatePerDay)) {
      this.errors.push('storageRatePerDay');
    }

    if (!this.isRate(data.rhdRate)) {
      this.errors.push('rhdRate');
    }

    if (!this.isSupplied(data.effectiveFrom)) {
      this.errors.push('effectiveFrom');
    }

    return this.errors.length === 0;
  }

  /** Supplied, numeric and not negative. Zero passes - free storage is a real agreement. */
  private isRate(value: number): boolean {
    return value !== null
      && value !== undefined
      && (value as any) !== ''
      && !isNaN(Number(value))
      && Number(value) >= 0;
  }
}
